import { fg } from '@atlassian/jira-feature-gating';
import { useAiPlannerUniversalCreateEnabled } from '@jira/ai-planning__ai-plans-overview/src/useAiPlannerUniversalCreateEnabled.tsx';
import { useHasActiveSoftwareAccess } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-project-common/src/controllers/has-active-software-access/index.tsx';
import { SOFTWARE_PROJECT } from '@jira/platform__project-types/src/project-types.tsx';
// eslint-disable-next-line jira/restricted/@jira+platform__services-providers-project-context
import { useProjectContext } from '@jira/platform__services-providers-project-context/src/index.tsx';

export const useShouldShowDefaultCreateButton = (): boolean => {
	const { data: projectContextData, key: projectContextResourceKey } = useProjectContext();
	const projectType = projectContextData?.projectType;
	const hasSoftwareAccess = useHasActiveSoftwareAccess();
	const aiPlannerEnabled = useAiPlannerUniversalCreateEnabled();
	const isBusinessProjectContext = projectContextResourceKey === 'BUS';

	// Valid software project if we are in a software project, or project type is unresolved and context is not business.
	const isValidSoftwareProject =
		projectType === SOFTWARE_PROJECT ||
		(hasSoftwareAccess &&
			projectType === undefined &&
			// This fixes a bug where business projects had undefined project type
			// We need to rely on resource key instead of project type
			// Instead of fixing outright, gating behind aiPlannerEnabled for now
			!(aiPlannerEnabled && isBusinessProjectContext));

	return (
		!isValidSoftwareProject || !aiPlannerEnabled || !fg('navx_onboarding_universal_create_in_jira')
	);
};
